<template>
  <footer class="footer" v-scrollanimation>
    <div class="container">
      <div class="footer__inner">
        <div class="footer__main flex f-wrap">
          <div class="column left-to-right delay-2">
            <a href="#" class="logo">
              <img class="logo__img" src="@/assets/logo_new.svg" alt="" />
            </a>
          </div>
          <div class="column">
            <h3 class="column__title hairline-1 w700 bottom-to-top">Меню</h3>
            <div class="menu flex-column">
              <router-link
                href="#"
                class="menu__link button-1 w400 bottom-to-top"
                v-for="(route, index) in menuRoutes"
                :to="$i18nRoute({ name: route })"
                :class="`delay-${index}`"
                :key="route"
                >{{ $t(`routes.${route}`) }}
              </router-link>
            </div>
          </div>
          <div class="column">
            <h3 class="column__title hairline-1 w700 bottom-to-top delay-3">
              Контакты
            </h3>
            <div class="contacts flex-column">
              <a
                :href="'tel:' + $t('phone_1')"
                class="contacts__caption bottom-to-top delay-4"
              >
                +{{ $t("phone_1") }}
              </a>
              <a
                :href="`mailto:${EMAIL}`"
                class="contacts__caption bottom-to-top delay-6"
              >
                {{ EMAIL }}
              </a>
              <p class="contacts__caption bottom-to-top delay-7">
                {{ $t("address") }}
              </p>
            </div>
          </div>
          <div class="column">
            <h3 class="column__title hairline-1 w700 bottom-to-top delay-5">
              Связь
            </h3>
            <div class="send flex f-wrap">
              <div class="bottom-to-top delay-6">
                <input
                  type="text"
                  class="send__input primary-input"
                  placeholder="Введите свой номер"
                  v-model="phone"
                />
              </div>
              <button
                @click="openModal()"
                class="send__button bottom-to-top delay-7"
              >
                <span>Отправить</span>
                <svg
                  width="1.3125rem"
                  height="1.25rem"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.1545 4.67969L16.1425 10.0003L11.1545 15.3209L10.4705 14.6797L14.418 10.469H5.5V9.53153H14.418L10.4705 5.32088L11.1545 4.67969Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="footer__bottom">
          <div class="social">
            <a
              href="https://t.me/Oneofradiant"
              target="_blank"
              class="social__link bottom-to-top delay-3"
            >
              <svg
                width="2rem"
                height="2rem"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 0.166504C9.49996 0.166504 0.166626 9.49984 0.166626 20.9998C0.166626 32.4998 9.49996 41.8332 21 41.8332C32.5 41.8332 41.8333 32.4998 41.8333 20.9998C41.8333 9.49984 32.5 0.166504 21 0.166504ZM30.6666 14.3332C30.3541 17.6248 29 25.6248 28.3125 29.3123C28.0208 30.8748 27.4375 31.3957 26.8958 31.4582C25.6875 31.5623 24.7708 30.6665 23.6041 29.8957C21.7708 28.6873 20.7291 27.9373 18.9583 26.7707C16.8958 25.4165 18.2291 24.6665 19.4166 23.4582C19.7291 23.1457 25.0625 18.2915 25.1666 17.854C25.1811 17.7877 25.1792 17.7189 25.161 17.6536C25.1429 17.5882 25.109 17.5283 25.0625 17.479C24.9375 17.3748 24.7708 17.4165 24.625 17.4373C24.4375 17.479 21.5208 19.4165 15.8333 23.2498C15 23.8123 14.25 24.104 13.5833 24.0832C12.8333 24.0623 11.4166 23.6665 10.3541 23.3123C9.04163 22.8957 8.02079 22.6665 8.10413 21.9373C8.14579 21.5623 8.66663 21.1873 9.64579 20.7915C15.7291 18.1457 19.7708 16.3957 21.7916 15.5623C27.5833 13.1457 28.7708 12.729 29.5625 12.729C29.7291 12.729 30.125 12.7707 30.375 12.979C30.5833 13.1457 30.6458 13.3748 30.6666 13.5415C30.6458 13.6665 30.6875 14.0415 30.6666 14.3332Z"
                  fill="white"
                />
              </svg>
            </a>
            <a class="social__link bottom-to-top delay-4">
              <svg
                width="2rem"
                height="2rem"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32 16.0978C32 7.20722 24.8366 0 16 0C7.16344 0 0 7.20722 0 16.0978C0 24.1325 5.85094 30.7924 13.5 32V20.751H9.4375V16.0978H13.5V12.5512C13.5 8.51673 15.8888 6.2882 19.5434 6.2882C21.2934 6.2882 23.125 6.60261 23.125 6.60261V10.5642H21.1075C19.12 10.5642 18.5 11.8051 18.5 13.0794V16.0978H22.9375L22.2281 20.751H18.5V32C26.1491 30.7924 32 24.1325 32 16.0978Z"
                  fill="white"
                />
              </svg>
            </a>
            <a class="social__link bottom-to-top delay-5">
              <svg
                width="2rem"
                height="2rem"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 0.166504C26.6604 0.166504 27.3666 0.187337 29.5875 0.291504C31.8062 0.39567 33.3166 0.743587 34.6458 1.26025C36.0208 1.78942 37.1791 2.50609 38.3375 3.66234C39.3968 4.70379 40.2165 5.96356 40.7395 7.354C41.2541 8.68109 41.6041 10.1936 41.7083 12.4123C41.8062 14.6332 41.8333 15.3394 41.8333 20.9998C41.8333 26.6603 41.8125 27.3665 41.7083 29.5873C41.6041 31.8061 41.2541 33.3165 40.7395 34.6457C40.218 36.0369 39.3981 37.297 38.3375 38.3373C37.2957 39.3963 36.036 40.216 34.6458 40.7394C33.3187 41.254 31.8062 41.604 29.5875 41.7082C27.3666 41.8061 26.6604 41.8332 21 41.8332C15.3395 41.8332 14.6333 41.8123 12.4125 41.7082C10.1937 41.604 8.68329 41.254 7.35413 40.7394C5.96314 40.2175 4.70314 39.3976 3.66246 38.3373C2.60289 37.2961 1.78315 36.0362 1.26038 34.6457C0.74371 33.3186 0.395793 31.8061 0.291626 29.5873C0.193709 27.3665 0.166626 26.6603 0.166626 20.9998C0.166626 15.3394 0.187459 14.6332 0.291626 12.4123C0.395793 10.1915 0.74371 8.68317 1.26038 7.354C1.7817 5.96271 2.60163 4.70259 3.66246 3.66234C4.70344 2.6024 5.96335 1.78261 7.35413 1.26025C8.68329 0.743587 10.1916 0.39567 12.4125 0.291504C14.6333 0.193587 15.3395 0.166504 21 0.166504ZM21 10.5832C18.2373 10.5832 15.5878 11.6806 13.6343 13.6341C11.6808 15.5876 10.5833 18.2372 10.5833 20.9998C10.5833 23.7625 11.6808 26.412 13.6343 28.3655C15.5878 30.319 18.2373 31.4165 21 31.4165C23.7626 31.4165 26.4122 30.319 28.3657 28.3655C30.3192 26.412 31.4166 23.7625 31.4166 20.9998C31.4166 18.2372 30.3192 15.5876 28.3657 13.6341C26.4122 11.6806 23.7626 10.5832 21 10.5832ZM34.5416 10.0623C34.5416 9.37167 34.2673 8.70929 33.7789 8.22091C33.2905 7.73254 32.6281 7.45817 31.9375 7.45817C31.2468 7.45817 30.5844 7.73254 30.096 8.22091C29.6077 8.70929 29.3333 9.37167 29.3333 10.0623C29.3333 10.753 29.6077 11.4154 30.096 11.9038C30.5844 12.3921 31.2468 12.6665 31.9375 12.6665C32.6281 12.6665 33.2905 12.3921 33.7789 11.9038C34.2673 11.4154 34.5416 10.753 34.5416 10.0623ZM21 14.7498C22.6576 14.7498 24.2473 15.4083 25.4194 16.5804C26.5915 17.7525 27.25 19.3422 27.25 20.9998C27.25 22.6574 26.5915 24.2472 25.4194 25.4193C24.2473 26.5914 22.6576 27.2498 21 27.2498C19.3424 27.2498 17.7526 26.5914 16.5805 25.4193C15.4084 24.2472 14.75 22.6574 14.75 20.9998C14.75 19.3422 15.4084 17.7525 16.5805 16.5804C17.7526 15.4083 19.3424 14.7498 21 14.7498Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
          <p class="copyright caption-1 w400 right-to-left delay-3">
            Copyright 2024 © Intersoft. All right reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { EMAIL } from "@/utils/constants";

const store = useStore();

const menuRoutes = ref(["AboutUs", "Portfolio", "Services", "Contacts"]);

const phone = ref("");

phone.value = computed(() => store.getters.callback.phone).value;

const openModal = () => {
  console.log(phone.value);
  store.commit("setCallback", { name: "", phone: phone.value });
  console.log(computed(() => store.getters.callback.phone).value);
  store.commit("setSendModal", true);
};
</script>
<style lang="scss" scoped>
.flex {
  &-column {
    display: flex;
    flex-direction: column;
  }
}

.footer {
  background: var(--blue-1);
  flex: 0 0 auto;

  &__inner {
    padding: 3.5rem 0;
  }

  &__main {
    display: flex;
    justify-content: space-between;
    border-bottom: 0.0625rem solid var(--gray-1);
    padding-bottom: 1rem;
    gap: 2rem;
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 2.5rem;
  }

  .social {
    display: flex;
    gap: 1.5rem;

    &__link {
      display: flex;
      align-items: center;

      svg {
        transition: all 0.3s ease;
        opacity: 0.7;
      }

      &:hover {
        svg {
          transform: scale(1.1);
          opacity: 1;
        }
      }
    }
  }

  .column {
    &__title {
      color: var(--white);
      margin-bottom: 0.75rem;
    }
  }

  .menu {
    &__link {
      padding: 0.25rem 0;
      color: var(--grey-3);

      &:first-child {
        padding-top: 0;
      }

      &:hover {
        color: var(--secondary-1);
        text-decoration: underline;
      }
    }
  }

  .contacts {
    max-width: 15.625rem;

    &__caption {
      padding: 0.25rem 0;
      color: var(--grey-3);

      &:first-child {
        padding-top: 0;
      }
    }
  }

  .send {
    max-width: 22rem;

    &__input {
      margin-bottom: 0.5rem;
      width: 22.5rem;
    }

    &__button {
      margin-bottom: 0.5rem;
      max-width: 10rem;
      font-weight: 500;
      font-size: 0.875em;
      line-height: 1.25em;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--primary-2);
      color: var(--white);
      padding: 0.625rem;
      border-radius: 3.125rem;
      cursor: pointer;
      opacity: 0.8;

      svg {
        margin-left: 0.5rem;
        path {
          fill: var(--white);
        }
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  .copyright {
    color: #ababab;
  }

  .logo {
    &__img {
      width: 8rem;
    }
  }
}

@media screen and (max-width: 1336px) {
  .footer {
    .send {
      &__input {
        width: 15rem;
      }
    }

    .column {
      flex: 1;

      &:nth-child(3) {
        flex: 2;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .footer {
    .send {
      max-width: 100%;

      &__input {
        margin-right: 1rem;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .footer {
    font-size: 16px;

    &__main {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .menu {
      &__link {
        margin-bottom: 0.5rem;
      }
    }

    .column {
      flex: 0 0 100%;
      width: 100%;

      &__title {
        margin-bottom: 1rem;
      }
    }

    .logo {
      &__img {
        width: 12rem;
      }
    }

    .contacts {
      max-width: 100%;
      align-items: center;

      &__caption {
        width: 100%;
        margin-bottom: 0.5rem;
      }
    }
    .send {
      flex-direction: column;
      max-width: 20rem;
      margin: 0 auto;
      margin-bottom: 2rem;

      &__input {
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 2rem;
      }

      &__button {
        width: 100%;
        min-width: 100%;
      }
    }

    &__bottom {
      flex-direction: column;
      text-align: center;
    }

    .social {
      margin-bottom: 2rem;

      &__link {
        svg {
          width: 3.5rem;
          height: 3.5rem;
        }
      }
    }
  }
}
</style>
